export default __webpack_public_path__ + "static/media/monitor.e52e6739.svg";